import { useTranslation } from "react-i18next";
import { _adr } from "../../../../address";
import { useDealer } from "../../../../tools/api";
import { switchPlanID } from "../../../../tools/services";
import { toman } from "../../../auxiliary/shop/ShopPage";
import WalletPrefactor, { useTaxPercent } from "../../../auxiliary/shop/WalletPrefactor";
import { PackageFeatures, PackageTypeTag } from "../packageInfo";
import "../ep.scss";

export const EP_STEPS = ["انتخاب بسته", "پیش فاکتور", "رسید"];
const SHOP = _adr.EPPurchase.Index + _adr.EPPurchase.Shop;

// the customer pays price + tax; the wallet pays that minus the (rounded) dealer commission.
// nothing is priced until the tax percent arrives. Also used by the summary on the first step.
export const packageMath = (price, tax, cpcommission) => {
	const taxPrice = tax > 0 ? (price * tax) / 100 : 0;
	const total = tax > 0 ? price + taxPrice : 0;
	const commission = tax > 0 ? (total * cpcommission) / 100 : 0;
	const walletDebit = tax > 0 ? Math.round(total - Math.round(commission)) : 0;
	return { taxPrice, total, commission, walletDebit };
};

const EPPrefactor = () => {
	const [t] = useTranslation("global");
	const { completeEPPurchase } = useDealer();
	const tax = useTaxPercent();

	const invoice = (order, user) => {
		const pkg = order?.package;
		const price = pkg?.packagePrice;
		const { taxPrice, total, commission, walletDebit } = packageMath(price, tax, user?.cpcommission);
		return {
			details: (
				<>
					<h4>مشخصات بسته </h4>
					<div className="list-item">
						<div className="item">
							<div className="label">نوع بسته:</div>
							<div className="value">
								<span dir="ltr">
									<PackageTypeTag pkg={pkg} />
								</span>
							</div>
						</div>
						<div className="item">
							<div className="label">قیمت:</div>
							<div className="value">{toman(price)}</div>
						</div>
						<div className="item">
							<div className="label">مشخصات:</div>
							<div className="value">
								<span>
									{pkg?.packageName}
									<PackageFeatures pkg={pkg} plus />
								</span>
							</div>
						</div>
					</div>
				</>
			),
			rows: [
				["مبلغ بسته", price],
				[`مالیات (${tax}درصد)`, taxPrice],
				["مبلغ قابل دریافت از مشتری", total],
				["مبلغ سود شما از فروش", commission],
				["مبلغ برداشت از کیف پول", walletDebit],
			],
			walletDebit,
		};
	};

	return (
		<WalletPrefactor
			title={t("extraPackage.title")}
			prefix="ep"
			steps={EP_STEPS}
			simLabel="سیم‌کارت اعتباری"
			stateKey="epPackage"
			chargePlanId={process.env.REACT_APP_PLANID_CHARGE_WALLET_EP}
			invoice={invoice}
			pay={(order) => completeEPPurchase({ msisdn: order?.msisdn, planid: switchPlanID().extraPackage, packagecode: order?.package?.packageCode })}
			finalPath={SHOP + _adr.EPPurchase.Final}
			finalState={(response, order) => ({ ...response, purchase: order?.purchase || null })}
			backPath={SHOP + _adr.EPPurchase.Valid}
		/>
	);
};

export default EPPrefactor;
